export const postEvents = {
  post_click: "academy_post_click" as const,
};

export type PostEvents = typeof postEvents;
